import { apiWithPrefix as api } from '../utils/api';

export class SettingsService {
  static async getHRSettings() {
    const response = await api.get('/hr-settings');
    return response.data;
  }

  static async updateHRSettings(data) {
    const response = await api.put('/hr-settings', data);
    return response.data;
  }

  static async resetHRSettings() {
    const response = await api.post('/hr-settings/reset-defaults');
    return response.data;
  }
}

export default SettingsService;
